<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">아이디</td>
                <td>
                    <div>
                        {{ boardData.Writer.mb_id }}
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">닉네임(이름)</td>
                <td>
                    <div>
                        {{ boardData.Writer.mb_nick }}
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">제목</td>
                <td>
                    <div>
                        {{ boardData.wr_subject }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">내용</td>
                <td>
                    <div v-html="replaceBr(boardData.wr_content)">
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">첨부이미지</td>
                <td>
                    <div>
                        <img v-if="hasFile" :src="returnImg()" alt="">
                    </div>
                </td>
            </tr>
            <div class="sub_title mt10 mb10">답변</div>
            <tr>
                <td class="c_t_title">제목</td>
                <td>
                    <div>
                        <el-input v-model="title" maxlength="30" @input="parentChange('title', title)"></el-input>
                        <div class="input_error" v-html="validation.firstError('title')"></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">내용</td>
                <td>
                    <div>
                        <quill-editor
                            ref="contentEditor"
                            class="h300"
                            v-model="content"
                            :options="editorOption"
                        />
                        <div class="input_error" v-html="validation.firstError('content')"></div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import boardValidator from "@/mixins/validators/boardValidator";
import memberUtil from "@/components/member/memberUtil";
import {runFileDown} from "@/mixins/fileApiDown"
import elFileMixins from "@/mixins/elFileMixins";
import dateMixins from "@/mixins/dateMixins";
import quillEditorMixins from "@/mixins/quillEditorMixins";

export default {
    name: "BoardWriteQnaLayout",
    mixins: [alertMixins, boardValidator, memberUtil, elFileMixins, dateMixins, quillEditorMixins],
    components: {},
    inject: {
        boardWriteSetData: {
            default: () => {
            }
        },
    },
    provide() {
        return {}
    },
    props: {
        boardData: {
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            filesUser: [],
        }
    },
    created() {
    },
    mounted() {
        if (this.hasBoardData()) {
            this.initSetData();
        }
        EventBus.$on('BoardWriteQnaLayoutValidator', this.checkValidator);
    },
    beforeDestroy() {
        EventBus.$off('BoardWriteQnaLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        hasBoardData() {
            return !util.isEmpty(this.boardData);
        },
        initSetData() {
            this.title = this.returnComment('wr_subject');
            this.parentChange('title', this.title);
            this.content = this.returnComment('wr_content');

            this.content = util.htmlDecode(this.content);
            this.parentChange('content', this.content);
            this.wid = this.returnComment('wr_id');
            this.parentChange('wid', this.wid)
            this.wp_id = this.boardData.wr_id;
            this.parentChange('wp_id', this.wp_id)
            if (!util.isEmpty(this.boardData.File) && !util.isEmpty(this.boardData.File.user)) {
                this.boardData.File.user[0].url = this.boardData.File.user[0].org_url;
                this.filesUser = this.boardData.File.user
            }
            if (!util.isEmpty(this.boardData.Comment.List) && !util.isEmpty(this.boardData.File) && !util.isEmpty(this.boardData.File.admin) && !util.isEmpty(this.boardData.File.admin[0].a_idx)) {
                this.boardData.File.admin[0].url = this.boardData.File.admin[0].org_url;
                this.files = this.boardData.File.admin
            }
        },

        returnDate(date = null) {
            if (!date) {
                return '';
            }
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        },
        returnComment(commentType) {
            return !util.isEmpty(this.boardData.Comment.List) ? this.boardData.Comment.List[0][commentType] : ''
        },
        returnCommentDate() {
            let date = this.returnComment('created_at');
            return date === '' ? '' : this.$moment(date).format('YYYY-MM-DD HH:mm')

        },
        parentChange(key, value) {
            if(key === 'content'){
                this.content = this.replaceN(value);
                value = this.content
            }
            this.boardWriteSetData(key, value)

        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },

        hasFile() {
            return !util.isEmpty(this.boardData.File[0].org_url)
        },
        returnImg() {
            if (util.isEmpty(this.boardData.File[0].org_url)) {
                return '';
            }
            return `${this.boardData.File[0].org_url}`;
        },
        replaceBr(content) {
            if (util.isEmpty(content)) {
                return '';
            }
            return content.replace(/(\n|\r\n)/g, '<br>');
        },
    },
    watch: {
        'content': {
            deep: true,
            handler: function (val, oldVal) {
                this.parentChange('content', this.content)
            },
        }
    },
}
</script>

<style scoped>

</style>
